module.exports = __webpack_public_path__ + "static/media/19ESCAP12.42a62a5d.jpg";